import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F1s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      unidad_administrativa: "",
      plazas: [],
      total_plazas: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f1s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F1/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f1s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/1/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  addPlaza = (e) => {
    let plaza = { nombre: "", num_plazas: 0, comisionados_al_area: 0, comisionados_por_el_area: 0, total_puesto: 0 }
    let plazas = [...this.state.plazas, plaza]
    this.setState({ plazas: plazas })
  };

  dellPlaza = (i) => {
    let plazas = this.state.plazas
    plazas.splice(i, 1)
    this.setState({ plazas: plazas })
  };

  onChangeNombre = (i, e) => {
    let plazas = [...this.state.plazas]
    let plaza = { ...plazas[i] }
    plaza.nombre = e.target.value
    plazas[i] = plaza
    this.setState({ plazas: plazas })
  };

  onChangeNumPlazas = (i, e) => {
    let plazas = [...this.state.plazas]
    let plaza = { ...plazas[i] }
    plaza.num_plazas = e.target.value
    plaza.total_puesto = parseInt(plaza.num_plazas) + parseInt(plaza.comisionados_al_area) - parseInt(plaza.comisionados_por_el_area)
    plazas[i] = plaza
    let total_plazas = 0
    for (let i = 0; i < plazas.length; i++) {
      total_plazas = total_plazas + plazas[i].total_puesto;
    }
    this.setState({ plazas: plazas, total_plazas: total_plazas })
  };

  onChangeComisionadosAlArea = (i, e) => {
    let plazas = [...this.state.plazas]
    let plaza = { ...plazas[i] }
    plaza.comisionados_al_area = e.target.value
    plaza.total_puesto = parseInt(plaza.num_plazas) + parseInt(plaza.comisionados_al_area) - parseInt(plaza.comisionados_por_el_area)
    plazas[i] = plaza
    let total_plazas = 0
    for (let i = 0; i < plazas.length; i++) {
      total_plazas = total_plazas + plazas[i].total_puesto;
    }
    this.setState({ plazas: plazas, total_plazas: total_plazas })
  };

  onChangeComisionadosPorElArea = (i, e) => {
    let plazas = [...this.state.plazas]
    let plaza = { ...plazas[i] }
    plaza.comisionados_por_el_area = e.target.value
    plaza.total_puesto = parseInt(plaza.num_plazas) + parseInt(plaza.comisionados_al_area) - parseInt(plaza.comisionados_por_el_area)
    plazas[i] = plaza
    let total_plazas = 0
    for (let i = 0; i < plazas.length; i++) {
      total_plazas = total_plazas + plazas[i].total_puesto;
    }
    this.setState({ plazas: plazas, total_plazas: total_plazas })
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      unidad_administrativa: "",
      plazas: [],
      total_plazas: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      unidad_administrativa: row.unidad_administrativa,
      plazas: JSON.parse(row.plazas),
      total_plazas: row.total_plazas,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      unidad_administrativa: row.unidad_administrativa,
      plazas: JSON.parse(row.plazas),
      total_plazas: row.total_plazas,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      unidad_administrativa: this.state.unidad_administrativa,
      plazas: this.state.plazas,
      total_plazas: this.state.total_plazas,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};
    axios.post("http://143.198.191.211/api/F1", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      unidad_administrativa: this.state.unidad_administrativa,
      plazas: this.state.plazas,
      total_plazas: this.state.total_plazas,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .put("http://143.198.191.211/api/F1/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F1/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeUnidadAdministrativa = e => {
    this.setState({ unidad_administrativa: e.target.value });
  };

  onChangePlazas = e => {
    this.setState({ plazas: e.target.value });
  };

  onChangeTotalPlazas = e => {
    this.setState({ total_plazas: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"1"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "unidad_administrativa",
        text: "Unidad Administrativa",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_plazas",
        text: "Total Plazas",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ORGANIGRAMAS DEL AYUNTAMIENTO</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 1 referente
                a organigramas del ayuntamiento, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f1s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="1" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=1"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12">
                <Form.Label>
                  Unidad Administrativa:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="unidad_administrativa"
                  value={this.state.unidad_administrativa}
                  onChange={this.onChangeUnidadAdministrativa}
                />
              </Col>
              <Col xs="12">
                {
                  (this.state.plazas).map((ele, i) =>
                    <Row key={i}>
                      <Col xs="12" md="1"></Col>
                      <Col xs="11">
                        <Form.Label>
                          Puesto:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="nombre"
                          value={ele.nombre}
                          onChange={(e) => this.onChangeNombre(i, e)}
                        />
                      </Col>
                      <Col xs="12" md="1"></Col>
                      <Col xs="12" md="2">
                        <Form.Label>
                          No. de Plazas:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="num_plazas"
                          value={ele.num_plazas}
                          onChange={(e) => this.onChangeNumPlazas(i, e)}
                        />
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label>
                          Comisionados al Área:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="comisionados_al_area"
                          value={ele.comisionados_al_area}
                          onChange={(e) => this.onChangeComisionadosAlArea(i, e)}
                        />
                      </Col>

                      <Col xs="12" md="2">
                        <Form.Label>
                          Comisionados por el Área:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="comisionados_por_el_area"
                          value={ele.comisionados_por_el_area}
                          onChange={(e) => this.onChangeComisionadosPorElArea(i, e)}
                        />
                      </Col>

                      <Col xs="12" md="2">
                        <Form.Label>
                          Subtotal:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="total_puesto"
                          value={ele.total_puesto}
                          readOnly
                        />
                      </Col>

                      <Col xs="12" md="1">
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Puesto." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                        <br></br>
                        <button
                          className="btn btn-danger"
                          onClick={(e) => this.dellPlaza(i, e)}
                          data-tip="Eliminar Puesto"
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      </Col>
                    </Row>
                  )
                }

                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addPlaza}
                      data-tip="Agregar Puesto"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Puesto
                    </button>
                  </Col>
                </Row>
              </Col>



              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Total Plazas:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="total_plazas"
                  value={this.state.total_plazas}
                  readOnly
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Comentarios que se consideren  pertinentes con respecto a la información señalada." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit}>
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Unidad Administrativa:
                    </Col>
                    <Col xs={10}>{this.state.unidad_administrativa}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Plazas:
                    </Col>
                    <Col xs={10}>{this.state.total_plazas}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>
                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F1s;
